import { render, staticRenderFns } from "./Enviadas.vue?vue&type=template&id=15ac2210&scoped=true"
import script from "./Enviadas.vue?vue&type=script&lang=js"
export * from "./Enviadas.vue?vue&type=script&lang=js"
import style0 from "./Enviadas.vue?vue&type=style&index=0&id=15ac2210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac2210",
  null
  
)

export default component.exports